<template>
    <div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Masonry from 'masonry-layout';
    import imagesLoaded from 'imagesloaded';
	export default {
		name: 'userContentLibLoader',
		props: {
            libs: Array
        },
        data: function() {
        	return {
                resolvedLibs: 0,
                facebookScriptLoaded: false,
                twitterScriptLoaded: false,
                instagramScriptLoaded: false,
                pinterestScriptLoaded: false,
                metaPixelLoaded: false
        	}
        },
        created: function() {
            var self = this;
            if (this.libs.indexOf('IMAGES') > -1) {
                this.loadImages();
            }
            window.addEventListener('CmpConsentUpdate', function(e) {
            	if (self.libs.indexOf('INSTAGRAM') > -1) {
	            	if(e.detail['consent_5e7e5243b8e05c1c467daa57']) {
	                    if(!self.instagramScriptLoaded) {
	                    	self.loadInstagram();
	                    }
	                } else {
                        if(self.instagramScriptLoaded) {
                            self.redrawUserContent();
                        }
                    }
            	}
            	if (self.libs.indexOf('TWITTER') > -1) {
	            	if(e.detail['consent_5e71760b69966540e4554f01']) {
	            		if(!window.twttr && !self.twitterScriptLoaded) {
	            			self.loadTwitter();
	            		}
	            	} else {
	            		if(self.twitterScriptLoaded) {
	            			self.redrawUserContent();
	            		}
	            	}
            	}
            	if (self.libs.indexOf('FACEBOOK') > -1) {
	            	if(e.detail['consent_5e716fc09a0b5040d575080f']) {
	                    if(!self.facebookScriptLoaded) {
	                    	setTimeout(function() {
	                    		self.loadFacebook();
	                    	}, 1000);
	                    }
	                } else {
	                	if(self.facebookScriptLoaded) {
                            self.redrawUserContent();
                        }
	                }
            	}
            	if (self.libs.indexOf('PINTEREST') > -1) {
	            	if(e.detail['consent_5e839a38b8e05c4e491e738e']) {
	                    if(!self.pinterestScriptLoaded) {
	                    	self.loadPinterest();
	                    }
	                } else {
                        if(self.pinterestScriptLoaded) {
                            self.redrawUserContent();
                        }
                    }
            	}
            });
        },
        methods: {
            loadTwitter: function() {
            	console.log('loadTwitter');
                var self = this;
                window.twttr = (function(d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0],
                    t = window.twttr || {};
                    if (d.getElementById(id)) return t;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "https://platform.twitter.com/widgets.js";
                    fjs.parentNode.insertBefore(js, fjs);

                    t._e = [];
                    t.ready = function(f) {
                        t._e.push(f);
                    };
                    return t;
                }(document, "script", "twitter-wjs"));
                console.log('created twttr variable');
                window.twttr.ready(function (twttr) {
                    console.log('binding for twitter loaded registred');
                    twttr.events.bind('loaded', self.twitterLoaded);
                    });
                this.twitterScriptLoaded = true;
            },
            loadFacebook: function() {
            	console.log('loadFacebook');
                var self = this;
                window.fbAsyncInit = function() {
                    FB.init({
                        appId            : '1431287560422009',
                        autoLogAppEvents : true,
                        xfbml            : true,
                        version          : 'v17.0'
                    });
                    FB.AppEvents.logPageView();
                    FB.Event.subscribe('xfbml.render', self.facebookLoaded);
                };
                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "//connect.facebook.net/de_DE/sdk.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));
                this.facebookScriptLoaded = true;
                
                //meta pixel
                if(!this.metaPixelLoaded) {
	                let noscript = document.createElement('noscript');
	                noscript.innerHTML = '<img height="1" width="1" style="display:none" src=https://www.facebook.com/tr?id=1004246707983925&ev=PageView&noscript=1 />';
	                document.head.append(noscript);
	                
	                !function(f,b,e,v,n,t,s) {
	                	if(f.fbq)return;
	                	n=f.fbq=function(){
	                		n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments)
	                	};
						if(!f._fbq)f._fbq=n;
						n.push=n;
						n.loaded=!0;
						n.version='2.0';
						n.queue=[];
						t=b.createElement(e);
						t.async=!0;
						t.src=v;
						s=b.getElementsByTagName(e)[0];
						s.parentNode.insertBefore(t,s)
					}(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js');
					fbq('init', '1004246707983925');
					fbq('track', 'PageView');
					fbq('track', 'ViewContent');
					fbq('track', 'Lead');
					
					//event used for registration success
					let event = new CustomEvent("fbqReady", { });
					document.dispatchEvent(event);
					
					this.metaPixelLoaded = true;
				}
            },
            loadInstagram: function() {
            	console.log('loadInstagram');
                var self = this;
                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "//www.instagram.com/embed.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'instagram-embeds'));
                window.__igEmbedLoaded = this.instagramLoaded;
                this.instagramScriptLoaded = true;
            },
            loadPinterest: function() {
            	console.log('loadPinterest');
                var self = this;
                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "//assets.pinterest.com/js/pinit.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'pinterest-pinit'));
                this.observePinterest();
                this.pinterestScriptLoaded = true;
            },
            loadImages: function() {
                imagesLoaded.makeJQueryPlugin($);
                var self = this;
                $('.grid').imagesLoaded().always(function() {
                    self.imagesLoaded();
                });
            },
            observePinterest: function() {
                if ($("a[data-pin-do]").length === 0)  {
                    console.log('Pinterest Processed: no more unprocessed anchors');
                    this.resolveLib('PINTEREST', 800);
                    return;
                }
                var self = this;
                setTimeout(function() {
                    self.observePinterest()
                }, 100);
            },
            twitterLoaded: function(event) {
                console.log('Twitter loaded called');
                event.widgets.forEach(function (widget) {
                    console.log("Created widget", widget.id);
                });
                this.resolveLib('TWITTER', 500);
            },
            facebookLoaded: function(event) {
                console.log('Facebook loaded called');
                this.resolveLib('FACEBOOK', 800);
            },
            instagramLoaded: function(event) {
                console.log('Instagram loaded called');
                this.resolveLib('INSTAGRAM', 800);
            },
            imagesLoaded: function(event) {
                console.log('Images loaded called');
                this.resolveLib('IMAGES', 500);
            },
            resolveLib: function(lib, delay) {
                this.resolvedLibs = this.resolvedLibs + 1;
                if(this.resolvedLibs >= this.libs.length) {
                	setTimeout(function() {
                        self.redrawUserContent();
                    }, 2000);
                }
                console.log('resolved libs ' + this.resolvedLibs);
                var self = this;
                if (delay <= 0) {
                    Vue.nextTick(function() {
                        self.redrawUserContent();
                    });
                } else {
                    setTimeout(function() {
                        self.redrawUserContent();
                    }, delay);
                }
            },
            redrawUserContent: function() {
                var elements = document.getElementsByClassName('grid');
                var msnry;

                // init Isotope after all images have loaded
                var n = elements.length;
                for(var i = 0; i < n; i++){
                    msnry = new Masonry( elements[i], {
                        itemSelector: '.grid-item',
                        columnWidth: '.grid-item',
                        percentPosition: true
                    });
                }
            }
        }
	}
</script>


// WEBPACK FOOTER //
// UserContentLibLoader.vue?119250f2